import { ADD_COMMENT } from 'root/src/client/logic/comment/actionIds'

export default body => ({
	type: ADD_COMMENT,
	payload: { body },
})
